import { Locale } from '@cars4ever/public-ui';

export interface IDeliveryFeeConfig {
  isIncluded: boolean;
}

const deliveryFeeConfigMap: Record<Locale, IDeliveryFeeConfig> = {
  [Locale.DK]: {
    isIncluded: true,
  },
  [Locale.SE]: {
    isIncluded: false,
  },
};

export default deliveryFeeConfigMap;
